// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5c9e0c3","504":"fff3144d"}[chunkId] + ".chunk.js";
};